import { Navigate, Outlet } from 'react-router-dom';
import { Box } from '@mui/material';
import { LOGIN } from 'Shared/Routing/Application/Constants/PathsConstant';
import { useAuthContext } from 'Shared/Security/Domain/Contexts/authContext';
import ImpersonationBanner from 'Shared/Security/Application/Components/ImpersonationBanner';

export default function PrivateRoute() {
  const { isAuthenticated, isImpersonating } = useAuthContext();

  if (!isAuthenticated) {
    return <Navigate to={LOGIN} />;
  }

  let targetPath = new URLSearchParams(window.location.search).get('targetPath');
  if (targetPath) {
    return <Navigate to={targetPath} />;
  }

  if (isImpersonating) {
    return (
      <Box sx={{ display: 'flex', flexDirection: 'column', height: '100vh', width: '100vw', overflow: 'hidden' }}>
        <ImpersonationBanner />
        <Box sx={{ flex: 1, minHeight: 0, height: 'calc(100vh - 38px)', overflow: 'hidden' }}>
          <Outlet />
        </Box>
      </Box>
    );
  }

  return (
    <>
      <Outlet />
    </>
  );
}


